import { useHistory } from 'react-router-dom';
import Parser from 'html-react-parser';
import l from '../../../lang';
import { Routes } from '../../../config/routes';
import TopDashboardSection from '../../common/top-dashboard-section';
import Card from '../../common/card';
import CardInfo from '../../common/card-info';
import Popup from '../../common/popup';
import AlertMessages from '../alert-messages';
import { ReactComponent as InfoIcon } from '../../../assets/icons/info-unfilled.svg';
import { ReactComponent as PaymentLinkIcon } from '../../../assets/icons/payment-link.svg';
import { ReactComponent as SubscriptionsIcon } from '../../../assets/icons/subscriptions.svg';
import { ReactComponent as PaymentButtonIcon } from '../../../assets/icons/payment-button.svg';
import './styles.scss';

interface ChargeOption {
  id: string;
  labelKey: string;
  tooltipKey: string;
  route: string;
  icon: React.ReactNode;
}

const Charges = () => {
  const history = useHistory();

  const options: ChargeOption[] = [
    {
      id: 'payment-link',
      labelKey: 'home.product.payment.link',
      tooltipKey: 'charges.paymentLink.tooltip',
      route: Routes.CREATED_PAYMENT_LINKS,
      icon: <PaymentLinkIcon className="charges-hub__icon charges-hub__icon--svg" aria-hidden />,
    },
    {
      id: 'subscriptions',
      labelKey: 'menu.subItem.SUBSCRIPTIONS',
      tooltipKey: 'charges.subscriptions.tooltip',
      route: Routes.SUBSCRIPTIONS,
      icon: <SubscriptionsIcon className="charges-hub__icon charges-hub__icon--svg" aria-hidden />,
    },
    {
      id: 'payment-button',
      labelKey: 'menu.subItem.PAYMENT_BUTTON',
      tooltipKey: 'charges.paymentButton.tooltip',
      route: Routes.PAYMENT_BUTTON,
      icon: <PaymentButtonIcon className="charges-hub__icon charges-hub__icon--svg" aria-hidden />,
    },
  ];

  return (
    <div className="charges-hub">
      <TopDashboardSection title={l('menu.item.SIDEBAR_COBRAR')} subtitle={l('charges.subheadline')} />
      <AlertMessages />
      <Card className="charges-hub__card">
        <div className="charges-hub__grid" role="list">
          {options.map(option => (
            <CardInfo key={option.id} bottomElement={<div className="charges-hub__accent-line" />}>
              <button
                type="button"
                className="charges-hub__item"
                role="listitem"
                onClick={() => history.push(option.route)}
              >
                <div
                  className="charges-hub__info"
                  onClick={e => e.stopPropagation()}
                  onKeyDown={e => e.stopPropagation()}
                >
                  <Popup
                    text={Parser(l(option.tooltipKey))}
                    icon={<InfoIcon className="charges-hub__info-icon" aria-hidden />}
                  />
                </div>
                <div className="charges-hub__icon-wrap">{option.icon}</div>
                <div className="charges-hub__label">{l(option.labelKey)}</div>
              </button>
            </CardInfo>
          ))}
        </div>
      </Card>
    </div>
  );
};

export default Charges;
